import uuid from 'js/src/libs/uuid';

export function gaSendPlanPurchase(name: string, price: number, lastUpsell?: string) {
    if (SERVER.USER === null) {
        return;
    }
    const transaction_id = uuid();

    gtag('event', 'purchase', {
        transaction_id: transaction_id, // Transaction ID. Required.
        affiliation: SERVER.USER?.id, // Affiliation or store name -- user id for us
        value: price, // Grand Total.
        last_upsell: lastUpsell, // Upsell the user clicked before purchasing, if known.
        items: [
            {
                id: transaction_id,
                name: name, // Product name. Required.
                price: price, // Unit price.
                quantity: 1,
            },
        ],
    });
}
